import * as types from 'misc/types';
import * as actions from 'misc/actions';

const company = (state = actions.initial(), action) => {
    switch (action.type) {
        case types.SAGA_COMPANY_GET.REQUEST:
            return actions.load(state);
        case types.SAGA_COMPANY_GET.SUCCESS:
            return actions.save(state, action.payload);
        case types.SAGA_COMPANY_GET.FAILURE:
            return actions.error(state, action.error);

        default:
            return state;
    }
};

export default company;



// WEBPACK FOOTER //
// ./src/reducers/company.js